import React, { FC } from 'react';
import { PrimaryButton } from '@clover/web-lib-core/components';
import { AppActions } from './types';
import { useTranslation } from 'react-i18next';
import { usePermission } from '../../../hooks/usePermission';
import { AppMarketPermissions } from '../../../models/enums';
import { canShowChangeSubscription } from '../../../component-helpers/app-actions';
import { App } from '../../../models/app';

interface ComponentProps {
  app: App;
  onClickHandler: () => void;
}

export const PreChangeSubscriptionButton: FC<ComponentProps> = ({ onClickHandler, app }) => {
  const { t } = useTranslation();
  const { enabled: hasInstallUninstallPermission } = usePermission(AppMarketPermissions.InstallUninstallApps);
  const buttonDisabled = !canShowChangeSubscription(app, hasInstallUninstallPermission);
  return (
    <PrimaryButton
      onClick={onClickHandler} disabled={buttonDisabled}>{t(AppActions.PreChangePricing)}</PrimaryButton>
  );
};
